import { Component, Input, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-catalog',
  standalone: false,
  templateUrl: './catalog.component.html',
  styleUrl: './catalog.component.scss',
})
export class CatalogComponent {

  @Input() form!: FormGroup;
  @Input() productCatalog: any;

}
